/* eslint-disable react/prop-types */
import { Dialog } from "primereact/dialog";
import { useState } from "react";

export default function Addandeditform(props) {
    const { visible, setVisible, formdata, handlechange, handlesave, handleupdate } = props;
    const [showOtherInput, setShowOtherInput] = useState(false);

       const handleKnowChange = (e) => {
        handlechange(e);
        setShowOtherInput(e.target.value === "Others");
    };

    return (
        <Dialog header="Course Form" visible={visible} onHide={() => { if (!visible) return; setVisible(false); }} style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} maximizable >
            <form onSubmit={!formdata._id ? handlesave : handleupdate}>
                <div className="grid grid-cols-1 gap-y-2">
                    <div>
                        <div>
                            <label>Your Photo</label>
                        </div>
                        <input type="file" name="ProfileImage"  className="w-full px-4 py-2 mt-1 border outline-none rounded-xl"
                            onChange={handlechange} />
                    </div>
                    <div className="mb-2">
                        <label>Aadhar Card</label>
                        <input type="file" name="Aadhar_card"  className="w-full px-4 py-2 border rounded-lg outline-none" onChange={handlechange} required />
                    </div>
                    <div>
                        <div>
                            <label>Full Name</label>
                        </div>
                        <input type="text" name="Full_name" value={formdata['Full_name']} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl"
                            onChange={handlechange} required />
                    </div>
                    <div>
                        <div>
                            <label>Date of Birth</label>
                        </div>
                        <input type="date" name="Dob" value={formdata['Dob']} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl"
                            onChange={handlechange} required />
                    </div>
                    <div>
                        <div>
                            <label>Gender</label>
                        </div>
                        <select
                            name="Gender"
                            value={formdata['Gender']}
                            className="w-full px-4 py-2 mt-1 border outline-none rounded-xl"
                            onChange={handlechange}
                            required
                        >
                            <option disabled selected>---Select a gender---</option>
                            <option>Male</option>
                            <option>Female</option>
                            <option>Trans.G</option>
                            <option>Diff. Abled</option>
                        </select>
                    </div>
                    <div>
                        <div>
                            <label>Address</label>
                        </div>
                        <input type="text" name="Address" value={formdata['Address']} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl"
                            onChange={handlechange} required />
                    </div>
                    <div>
                        <label>City</label>
                        <select name="City" value={formdata['City'] || ''} onChange={handlechange} className="w-full px-4 py-2 border rounded-lg outline-none">
                            <option value="">Select a District</option>
                            <option value="Ariyalur">Ariyalur</option>
                            <option value="Chengalpattu">Chengalpattu</option>
                            <option value="Chennai">Chennai</option>
                            <option value="Coimbatore">Coimbatore</option>
                            <option value="Cuddalore">Cuddalore</option>
                            <option value="Dharmapuri">Dharmapuri</option>
                            <option value="Dindigul">Dindigul</option>
                            <option value="Erode">Erode</option>
                            <option value="Kallakurichi">Kallakurichi</option>
                            <option value="Kanchipuram">Kanchipuram</option>
                            <option value="Kanyakumari">Kanyakumari</option>
                            <option value="Karur">Karur</option>
                            <option value="Krishnagiri">Krishnagiri</option>
                            <option value="Madurai">Madurai</option>
                            <option value="Mayiladuthurai">Mayiladuthurai</option>
                            <option value="Nagapattinam">Nagapattinam</option>
                            <option value="Namakkal">Namakkal</option>
                            <option value="Nilgiris">Nilgiris</option>
                            <option value="Perambalur">Perambalur</option>
                            <option value="Pudukkottai">Pudukkottai</option>
                            <option value="Ramanathapuram">Ramanathapuram</option>
                            <option value="Ranipet">Ranipet</option>
                            <option value="Salem">Salem</option>
                            <option value="Sivaganga">Sivaganga</option>
                            <option value="Tenkasi">Tenkasi</option>
                            <option value="Thanjavur">Thanjavur</option>
                            <option value="Theni">Theni</option>
                            <option value="Thoothukudi">Thoothukudi</option>
                            <option value="Tiruchirappalli">Tiruchirappalli</option>
                            <option value="Tirunelveli">Tirunelveli</option>
                            <option value="Tirupathur">Tirupathur</option>
                            <option value="Tiruppur">Tiruppur</option>
                            <option value="Tiruvallur">Tiruvallur</option>
                            <option value="Tiruvannamalai">Tiruvannamalai</option>
                            <option value="Tiruvarur">Tiruvarur</option>
                            <option value="Vellore">Vellore</option>
                            <option value="Viluppuram">Viluppuram</option>
                            <option value="Virudhunagar">Virudhunagar</option>
                        </select>
                        </div>
                    <div>
                        <label>Pincode</label>
                        <input name="Pincode" value={formdata['Pincode'] || ''} className="w-full px-4 py-2 border rounded-lg outline-none" onChange={handlechange}/>
                    </div>
                    <div>
                        <div>
                            <label>Community</label>
                        </div>
                        <input type="text" name="Community" value={formdata['Community']} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl"
                            onChange={handlechange} required />
                    </div>
                    <div>
                        <div>
                            <label>Father Name</label>
                        </div>
                        <input type="text" name="Father_Name" value={formdata['Father_Name']} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl"
                            onChange={handlechange} required />
                    </div>
                    <div>
                        <div>
                            <label>Occupation</label>
                        </div>
                        <input type="text" name="Occupation" value={formdata['Occupation']} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl"
                            onChange={handlechange} required />
                    </div>
                    <div>
                        <div>
                            <label>Mobile Number</label>
                        </div>
                        <input type="text" name="Mobile_Number" value={formdata['Mobile_Number']} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl"
                            onChange={handlechange} required />
                    </div>
                    <div>
                        <div>
                            <label>Alternative Number</label>
                        </div>
                        <input type="text" name="Alternative_Number" value={formdata['Alternative_Number']} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl"
                            onChange={handlechange} required />
                    </div>
                    <div>
                        <div>
                            <label>Email Address</label>
                        </div>
                        <input type="email" name="Email" value={formdata['Email']} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl"
                            onChange={handlechange} required />
                    </div>
                    <div>
                        <div>
                            <label>Educational Qualification</label>
                        </div>
                        <input type="text" name="Educational_Qualification" value={formdata['Educational_Qualification']} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl"
                            onChange={handlechange} required />
                    </div>
                    <div>
                        <div>
                            <label>Name of the college</label>
                        </div>
                        <input type="text" name="College_Name" value={formdata['College_Name']} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl"
                            onChange={handlechange} required />
                    </div>
                    <div>
                        <div>
                            <label>How did you come to know about Kavin&apos;s Academy?</label>
                        </div>
                        <select
                            name="how_you_know"
                            value={formdata['how_you_know']}
                            className="w-full px-4 py-2 mt-1 border outline-none rounded-xl"
                            onChange={handleKnowChange}
                            required
                        >
                            <option disabled selected>---Select a option---</option>
                            <option>Online</option>
                            <option>WhatsApp</option>
                            <option>Poster</option>
                            <option>Newspaper</option>
                            <option>Friends / Relatives</option>
                            <option>Others</option>
                        </select>
                    </div>
                     {showOtherInput && (
                    <div>
                        <div>
                            <label>Others: (Detail)</label>
                        </div>
                        <input type="text" name="how_you_know_others" value={formdata['how_you_know_others']} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl"
                            onChange={handlechange} />
                    </div>
                     )}
                    <div>
                        <div>
                            <label>Exam(s) preferred to start preparation?</label>
                        </div>
                        <select
                            name="preferred_exam"
                            value={formdata['preferred_exam']}
                            className="w-full px-4 py-2 mt-1 border outline-none rounded-xl"
                            onChange={handlechange}
                            required
                        >
                            <option disabled selected>---Select a option---</option>
                            <option>UPSC</option>
                            <option>TNPSC</option>
                            <option>IBPS</option>
                            <option>TET-TRB</option>
                            <option>SRB/DRB (Coop)</option>
                            <option>PD & Soft Skills</option>
                            <option>SI</option>
                            <option>NEET</option>
                            <option>CUET</option>
                            <option>Others</option>
                        </select>
                    </div>

                </div>

                <div className="flex justify-end gap-5 mt-5">
                    <button type="button" onClick={() => setVisible(false)}>
                        Cancel
                    </button>
                    <button
                        color="primary"
                        type="submit"
                        className="px-4 py-2 text-white bg-secondary rounded-xl"
                    >
                        <i className="fi fi-br-check"></i> {!formdata._id ? 'Save' : 'Update'}
                    </button>
                </div>
            </form>
        </Dialog>
    )
}